import { useEffect, useState, useMemo, useCallback } from "react";
import {Col} from 'reactstrap';
import { useMediaQuery } from 'react-responsive';
import { APIUS } from "../../../../../config/apius";
import "bulma/css/bulma.css";
import "../../../../../index.css";
import Swal from "sweetalert2";
import swal from "sweetalert";
import ModalAdd from "./modal/add";
import ModalUpdate from "./modal/update";
import ModalImport, { downloadStudentTemplate } from "./modal/import";
import { useLocation, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faMagnifyingGlass,
  faUsers,
  faFileExcel,
  faFileImport,
  faChevronLeft,
  faChevronRight
} from '@fortawesome/free-solid-svg-icons';
import { PulseLoader } from "react-spinners";
import ToastError from "../../../../NotificationToast/ToastError";

export default function ImportSiswaBaru() {
  document.title = "Import Siswa Baru";


  const [getData, setGetData] = useState([]);
  const ascending = 1;
  const token = localStorage.getItem("token");

  // Responsive to mobile or dekstop
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 780px)'});

  const [searchKeyword, setSearchKeyword] = useState("");
  const [tablePage, setTablePage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [isFetching, setIsFetching] = useState(false);

  const [id, setId] = useState();
  const [dataUpdate, setDataUpdate] = useState();

  const [modalAdd, setModalAdd] = useState(false);
  const [modalUpdate, setModalUpdate] = useState(false);
  const [modalImport, setModalImport] = useState(false);


  // Filter permission menu
  const location = useLocation();
  const [permission, setPermission] = useState({
    create: 0,
    read: 0,
    update: 0,
    delete: 0
  });

  const navigate = useNavigate();

  useEffect(() => {
    const storageLevel = localStorage.getItem('level');
    const storageItems = JSON.parse(localStorage.getItem('role_permission')) || [];

    if (storageLevel === "developer" || storageLevel === "superadmin") {
      setPermission({
        create: 1,
        read: 1,
        update: 1,
        delete: 1
      });
    } else {
      const foundPermission = storageItems.find(
        item => item.menu?.url === location.pathname
      );

      if (!foundPermission) { 
        navigate('/dashboard');
      } else {
        setPermission({
          create: foundPermission.create,
          read: foundPermission.read,
          update: foundPermission.update,
          delete: foundPermission.delete
        });
      }}
  }, [location.pathname, navigate]);

  const fetchParams = useMemo(
      () => ({
        headers: {
          Authorization: `${token}`,
          "Content-Type": "application/json",
        },
      }),
      [token]
  );

  // const GetResponseData = async () => {
  //   setSearchKeyword("");
  //   setIsFetching(true);

  //   try {
  //     // e.preventDefault();
  //     setLoading(true)
  //     const response = await APIUS.get(`/api/students?page=${page}&limit=${limit}&ascending=${ascending}&search=${keyword}`,fetchParams)

  //     // Checking process
  //     if (response?.status === 200) {
  //       setGetData(response.data.data)
  //       setPage(response.data.pagination.current_page);
  //       setPages(response.data.pagination.total_pages);
  //       setRows(response.data.pagination.total);
  //       setLoading(false)
  //       }
  //   } catch (error) {
  //     setLoading(false)
  //     swal({
  //       title: 'Failed',
  //       text: `${error.response.data.message}`,
  //       icon: 'error',
  //       timer: 3000,
  //       buttons: false
  //     });
  //   } finally {
  //     setIsFetching(false);
  //   }
  // }

    const GetResponseData = useCallback(async () => {
    setSearchKeyword("");
    setIsFetching(true);

    try {
      const response = await APIUS.get(
        `/api/students?page=1&limit=10000&ascending=${ascending}&search=`,
        fetchParams
      );

      if (response?.status === 200) {
        setGetData(response?.data?.data || []);
      }
    } catch (error) {
      ToastError.fire({
        icon: "error",
        title: error.response?.data?.message || "Gagal memuat data",
      });
    } finally {
      setIsFetching(false);
    }
  }, [ascending, fetchParams]);

  useEffect(() => {
    GetResponseData();
  }, [GetResponseData]);

  const deleteById = async (id) => {
    Swal.fire({
      title: 'Apakah Kamu Yakin?',
      text: `Menghapus data ini`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Ya, Hapus'
    }).then( async (result) => {
      if(result.isConfirmed) {
        const response =  await APIUS.delete(`/api/students/${id}`,fetchParams);
        if (response.data.error == false) {
          GetResponseData()
          swal({
            title: 'Success',
            text: "Data berhasil di hapus!",
            icon: 'success',
            timer: 3000,
            buttons: false
          });
        }  
      }
    })
  };
  
  const viewModalAdd = () => {
    setModalAdd(true)
  }

  const viewModalUpdate = (id, siswa) => {
    setModalUpdate(true)
    setId(id)
    setDataUpdate(siswa)
  }

  const nameCollator = useMemo(
      () => new Intl.Collator("id", { sensitivity: "base", numeric: true }),
      []
    );
  
  const filteredData = useMemo(() => {
    const keyword = (searchKeyword || "").trim().toLowerCase();
  
    const result = !keyword
      ? getData || []
      : (getData || []).filter((item) => {
          const namaSiswa = (item?.nama_lengkap || "")
          .toString()
          .toLowerCase();
        return (
          namaSiswa.includes(keyword) 
        );
      });
  
      return [...result].sort((a, b) =>
        nameCollator.compare(
          (a?.branch_name || "").toString().trim(),
          (b?.branch_name || "").toString().trim()
        )
      );
  }, [getData, searchKeyword, nameCollator]);
  
  const totalRows = filteredData.length;
  
  const totalPages = useMemo(() => {
    const pages = Math.ceil(totalRows / Math.max(1, rowsPerPage));
    return pages <= 0 ? 1 : pages;
  }, [totalRows, rowsPerPage]);
  
  useEffect(() => {
    setTablePage(1);
  }, [searchKeyword, getData]);
  
  useEffect(() => {
    if (tablePage > totalPages) setTablePage(totalPages);
    if (tablePage < 1) setTablePage(1);
  }, [tablePage, totalPages]);
  
  const paginatedData = useMemo(() => {
    const safeRows = Math.max(1, rowsPerPage);
    const start = (tablePage - 1) * safeRows;
    return filteredData.slice(start, start + safeRows);
  }, [filteredData, tablePage, rowsPerPage]);
  
  const pageNumbers = useMemo(() => {
    const maxButtons = 5;
    const pages = [];
  
    if (totalPages <= maxButtons) {
      for (let i = 1; i <= totalPages; i += 1) pages.push(i);

      return pages;
    }
  
    const left = Math.max(1, tablePage - 1);

    const right = Math.min(totalPages, tablePage + 1);
  
    pages.push(1);
    if (left > 2) pages.push("...");
  
    for (let i = left; i <= right; i += 1) {
      if (i !== 1 && i !== totalPages) pages.push(i);
    }
  
    if (right < totalPages - 1) pages.push("...");
      pages.push(totalPages);
  
      return pages.filter((value, index, array) => array.indexOf(value) === index);
  }, [tablePage, totalPages]);
  
  const goToPage = (nextPage) => {
    const page = Math.min(Math.max(1, Number(nextPage) || 1), totalPages);

    setTablePage(page);
  };
  
  const firstRow = totalRows === 0 ? 0 : (tablePage - 1) * rowsPerPage + 1;

  const lastRow = Math.min(tablePage * rowsPerPage, totalRows);

  return (
    <div className="body sims-page" >

      {modalAdd && (
        <ModalAdd
          GetResponseData={GetResponseData}
          show={modalAdd}
          onHide={() => setModalAdd(false)}
        />
      )}

      {modalUpdate && (
        <ModalUpdate
          GetResponseData={GetResponseData}
          id={id}
          dataUpdate={dataUpdate}
          show={modalUpdate}
          onHide={() => setModalUpdate(false)}
        />
      )}

      {modalImport && (
        <ModalImport 
          GetResponseData={GetResponseData} 
          show={modalImport} 
          onHide={() => setModalImport(false)} />
      )}
      
      <div className="page-header-card">
          <div className="page-header-top d-flex">
            <div className="page-title-wrap">
              <span className="page-title-icon">
                <FontAwesomeIcon icon={faUsers} />
              </span>
              <h4 className="page-title-text">Import Siswa Baru</h4>
            </div>
  
            <div className="ml-auto">
              <button 
                onClick={downloadStudentTemplate} 
                className="btn btn-outline-success sims-header-button" 
                style={{ fontWeight: "600" }}>
                <FontAwesomeIcon icon={faFileExcel} /> 
                <span> Template </span>
              </button>

              <button 
                onClick={() => setModalImport(true)} 
                className="btn btn-create sims-header-button ml-2" 
                >
                <FontAwesomeIcon icon={faFileImport} /> 
                <span> Import Siswa </span>
              </button>
            </div>
          </div>
        </div>

      <div className="body-content sims-content">
        {isFetching ? (
          <div className="sims-loading">
            <PulseLoader color="#3f5bea" size={12} />
          </div>
        ) : (
           <Col xl="12" sm="12" className="sims-column">
            <div className="sims-search-wrap mb-3">
              <FontAwesomeIcon
                icon={faMagnifyingGlass}
                className="sims-search-icon"
              />
              <input
                className="sims-search-input"
                placeholder="Cari Nama Siswa"
                value={searchKeyword}
                onChange={(event) => setSearchKeyword(event.target.value)}
              />
            </div>

              <div className="sims-table-card" >
                <div className="sims-table-scroll">
                  <table className="sims-table">
                    <thead>
                      <tr>
                        <th className="sims-col-number">No</th>
                        <th style={{width: "180px"}} >Tahun Ajaran</th>
                        <th >Nama Siswa</th>
                        <th>Cabang</th>
                        <th >Sekolah</th>
                      </tr>
                    </thead>

                    <tbody>
                      {paginatedData.length > 0 ? (
                        paginatedData.map((row, index) => (
                          <tr key={row?.id || index}>
                            <td className="sims-col-number">
                              <span className="sims-number-badge">
                                {(tablePage - 1) * rowsPerPage + index + 1}
                              </span>
                            </td>

                            <td>
                              <span className="sims-text-bold">
                                {row.name_academic_year|| "-"}
                              </span>
                            </td>

                            <td className="sims-text-bold">
                              <span >
                                {row.nama_lengkap || "-"}
                              </span>
                            </td>

                            <td>
                              <span>
                                {row.name_branch || "-"}
                              </span>
                            </td>

                            <td>
                              <span >
                                 {row.name_school || "-"}
                              </span>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="5" className="sims-empty-state">
                            <div className="sims-empty-state-content">
                              Data cabang tidak ditemukan
                            </div>
                          
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                {filteredData.length > 0 && (
                  <div className="sims-pagination">
                    <div className="sims-pagination-left">
                      <span className="sims-page-info">
                        Menampilkan <b>{firstRow}-{lastRow}</b> dari{" "}
                        <b>{totalRows}</b> data
                      </span>

                      <select
                        className="sims-page-size"
                        value={rowsPerPage}
                        onChange={(event) => {
                          const value = Number(event.target.value) || 10;
                          setRowsPerPage(value);
                          setTablePage(1);
                        }}
                      >
                        <option value={10}>10 / halaman</option>
                        <option value={25}>25 / halaman</option>
                        <option value={50}>50 / halaman</option>
                        <option value={100}>100 / halaman</option>
                      </select>
                    </div>

                    <div className="sims-pagination-right">
                      <button
                        type="button"
                        className="sims-page-nav"
                        onClick={() => goToPage(tablePage - 1)}
                        disabled={tablePage <= 1}
                      >
                        <FontAwesomeIcon icon={faChevronLeft} />
                        <span>Sebelumnya</span>
                      </button>

                      <div className="sims-page-numbers">
                        {pageNumbers.map((page, index) =>
                          page === "..." ? (
                            <span
                              key={`dots-${index}`}
                              className="sims-page-dots"
                            >
                              ...
                            </span>
                          ) : (
                            <button
                              type="button"
                              key={`page-${page}`}
                              className={`sims-page-number ${
                                page === tablePage ? "active" : ""
                              }`}
                              onClick={() => goToPage(page)}
                            >
                              {page}
                            </button>
                          )
                        )}
                      </div>

                      <button
                        type="button"
                        className="sims-page-nav"
                        onClick={() => goToPage(tablePage + 1)}
                        disabled={tablePage >= totalPages}
                      >
                        <span>Selanjutnya</span>
                        <FontAwesomeIcon icon={faChevronRight} />
                      </button>
                    </div>
                  </div>
                )}
              </div>
          </Col>
        )}
      </div>
    </div>
   );



}
